import {PeopleIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {ReviewerIdentity} from './ReviewerIdentity'
import type {Reviewer} from '@github-ui/dotcom-schema/types/pull_requests/v1/reviewer'
import styles from './OnBehalfOfTeams.module.css'

export function OnBehalfOfTeams({
  teams,
  className,
  withAvatar,
}: {
  teams: Reviewer[]
  className?: string
  withAvatar?: boolean
}) {
  if (teams.length === 0) return null

  return (
    <span className={clsx(styles.delegationNote, className)}>
      <PeopleIcon size={12} />
      on behalf of{' '}
      {teams.map((team, i) => (
        <span key={team.id.toString()} className={styles.nestedTeamList}>
          <ReviewerIdentity reviewer={team} withAvatar={withAvatar} inline />
          {i < teams.length - 1 && <span className={styles.separator}>, </span>}
        </span>
      ))}
    </span>
  )
}
